import { useCallback, useRef } from 'react'
import gsap from 'gsap'
import ScrollTrigger from 'gsap/dist/ScrollTrigger'
import { useLenis } from 'lenis/react'

import { useMotionTouchMedia } from '@/hooks/use-motion-touch-media'
import { useLoaderStore } from '@/store/loader'

import { createLinesMotion, getScrollTriggerOptions, Motion } from './shared'

export const useQuoteMotion = () => {
  const motionRef = useRef<HTMLDivElement>(null)
  const revealScrollTrigger = useRef<ScrollTrigger>(null!)
  const fontsReady = useLoaderStore((state) => state.fontsReady)
  const lenis = useLenis()

  const quoteMotion = useRef<Motion | null>(null)

  const revertSplitText = useCallback(() => {
    quoteMotion.current?.revert()
  }, [])

  /**
   * reveal setup
   */
  useMotionTouchMedia(
    {
      pointer({ selector }) {
        if (!fontsReady || !lenis) return

        const quote = selector?.('[data-motion-quote]')[0]

        quoteMotion.current = quote ? createLinesMotion(quote) : null

        const animation = gsap.timeline({ onComplete: revertSplitText })
        quoteMotion.current && animation.add(quoteMotion.current.timeline)

        revealScrollTrigger.current = ScrollTrigger.create({
          ...getScrollTriggerOptions({
            trigger: quote.parentNode,
            markers: false,
            animation
          })
        })
      },

      revert() {
        revertSplitText()
      }
    },
    { scope: motionRef, dependencies: [fontsReady, lenis] }
  )

  return { motionRef }
}
